import { useRouter } from "next/router";

export const useNumericIdFromURL = (attributeName: string) => {
  const router = useRouter();

  const value = router.query[attributeName];

  if (!value || isNaN(+value)) {
    return;
  }

  return +value;
};
